export default __webpack_public_path__ + "static/media/FoundersGrotesk-Regular.2320c0ba.ttf";